// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__N1Uw+","sign-block":"Footer_sign-block__TS0uB","header":"Footer_header__0eJdQ","sign":"Footer_sign__WXA3V","fio":"Footer_fio__wsg6L"};